<template>
  <div class="person-container flex">
    <left-nav-tab :code="code" :navList="navList" @handleTabPage="handleTabPage" />
    <div class="content-box">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import LeftNavTab from '@/components/leftNavTab'

export default {
  data () {
    return {
      code: 'orderListNew',
      path: 'personalCenter',
      navList: []
    }
  },
  components: {
    'left-nav-tab': LeftNavTab
  },
  created () {
    this.moduleType = this.$route.query.moduleType || 'TRIP'
    if (this.moduleType === 'RETAIL') {
      this.navList = [{
        code: '我的订单',
        child: [
          { name: '全部订单', code: 'orderListNew' },
          { name: '退款/售后', code: 'afterSalesOrderList' }
        ]
      }, {
        code: '常用信息',
        child: [{ name: '常用收货地址', code: 'receiveAddress' }]
      }, {
        code: '个人中心',
        child: [{ name: '个人信息', code: 'personalInfo' }]
      }]
    } else {
      this.navList = [{
        code: '我的订单',
        child: [{ name: '全部订单', code: 'orderListNew' }]
      }, {
        code: '个人中心',
        child: [{ name: '个人信息', code: 'personalInfo' }]
      }]
    }
    if (this.$route.path === '/personalInfo') {
      this.code = 'personalInfo'
    } else if (this.$route.path === '/receiveAddress') {
      this.code = 'receiveAddress'
    } else if (this.$route.path.indexOf('afterSales') !== -1) {
      this.code = 'afterSalesOrderList'
    }
  },
  methods: {
    handleTabPage (code) {
      this.code = code
      if (code === 'orderListNew') {
        if (this.moduleType === 'TRIP') {
          this.$router.replace({ path: '/tripOrderList', query: { t: Date.now(), moduleType: this.moduleType } })
          return
        } else if (this.moduleType === 'RETAIL') {
          this.$router.replace({ path: '/retailOrderList', query: { t: Date.now(), moduleType: this.moduleType } })
          return
        }
      }
      this.$router.push({
        path: code,
        query: { moduleType: this.moduleType }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.person-container {
  width: 1279px;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 24px;
  overflow-x: auto;
  // transform: translateX(-100px);
}
.content-box {
  min-height: 760px;
  z-index: 1;
  position: relative;
  width: 1050px;
  margin-left: 24px;
  background-color: #fff;
  box-shadow: 0px 3px 16px rgba(24, 60, 80, 0.08);
  border-radius: 8px;
}
</style>
